'use client';
import { useState, useCallback, useEffect } from 'react';
import { useRouter } from 'next/navigation';
import { UserContext } from '@/contexts/user-context-v2';
import { getUser } from '@/app/lib/data/user';
import localStorage from '@/src/local-storage';

export function UserProvider({ children, user: initialUser, error, ember }) {
  const [user, setUser] = useState(initialUser);
  const router = useRouter();
  
  // Handle localStorage operations and redirects on app bootstrap
  useEffect(() => {
    if (!user || user.isUnauthenticated) return;
    
    // Set user in localStorage
    localStorage.setUser(user);
    
    // Clear challenge cache
    localStorage.removeChallengeCache();
    
    // Handle any stored redirect
    const localStorageRedirect = localStorage.getRedirect();
    if (localStorageRedirect) {
      localStorage.removeRedirect();
      router.replace(localStorageRedirect);
    }
  }, [user, router]);
  
  const mutate = useCallback(async () => {
    if (!user) return null;
    if (!user?.token) return null;
    try {
      const updatedUser = await getUser(user.token)
      setUser(updatedUser);
      // Update localStorage when user data changes
      localStorage.setUser(updatedUser);
    } catch (err) {
      console.error('Failed to update user')
      console.log(err)
    }
  }, [user])

  const clearUserContext = () => {
    setUser(null);
    // Clear localStorage when user context is cleared
    localStorage.removeUser();
  }
  
  return (
    <UserContext.Provider value={{ user, error, mutate, clearUserContext, ember }}>
      {children}
    </UserContext.Provider>
  );
}